import React from "react";
import techoInterior from "../assets/limpieza-techo.webp";
import llantas from "../assets/limpieza-llantas.webp";
import butacas from "../assets/limpieza-butaca.webp";
import motor from "../assets/limpieza-motor.webp";
import opticas from "../assets/limpieza-opticas.webp";
import barro from "../assets/limpieza-barro.webp";

// Datos de los servicios adicionales con rutas a las imágenes
const services = [
  {
    title: "Limpieza de techo interior",
    price: 40000,
    image: techoInterior,
  },
  {
    title: "Descontaminación de llantas, disco de frenos y calippers",
    price: 40000,
    image: llantas,
  },
  {
    title: "Limpieza al detalle de butacas (Precio por butaca)",
    price: 35000,
    image: butacas,
  },
  {
    title: "Limpieza de motor",
    price: 90000,
    image: motor,
  },
  {
    title: "Tratamiento de restauración de ópticas",
    price: 90000,
    image: opticas,
  },
  {
    title: "Limpieza día de campo",
    price: 30000,
    image: barro,
  },
];

const AdditionalServicesWithImages: React.FC = () => {
  return (
    <section className="container mx-auto py-8 text-white">
      <h2 className="text-4xl font-bold text-center mb-8">
        Servicios Adicionales
      </h2>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
        {services.map((service, index) => (
          <div
            key={index}
            className="bg-[rgb(25,24,31)] p-6 rounded-2xl shadow-lg transition-shadow hover:shadow-2xl hover:scale-105 transform duration-300 ease-in-out"
          >
            <img
              src={service.image}
              alt={service.title}
              className="w-80 h-80 object-cover mx-auto mb-4 rounded-lg"
            />
            <h3 className="text-2xl font-bold mb-2 text-center">
              {service.title}
            </h3>
            <p className="text-3xl font-semibold text-center mb-4">
              ${service.price}
            </p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default AdditionalServicesWithImages;